const ordersFilter = {
  sortDir: 'asc',
  sortField: 'startAt',
  limit: 25,
  page: 1,
  startAtFrom: '',
  startAtTo: '',
  statuses: [],
  types: [],
}

export default {
  'order-list': ordersFilter,
}
